import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "KModalAction";
var classes = {
    button: "".concat(PREFIX, "-button"),
    buttonAlt: "".concat(PREFIX, "-buttonAlt"),
    loading: "".concat(PREFIX, "-loading")
};
var StyledKModalAction = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== "alt"; }
})(function (_a) {
    var _b;
    var theme = _a.theme, alt = _a.alt;
    return (_b = {
            display: "block",
            textAlign: "center",
            paddingTop: theme.spacing(2)
        },
        _b["& .".concat(classes.button)] = { minWidth: "50%" },
        _b["& .".concat(classes.buttonAlt)] = {},
        _b["& .".concat(classes.loading)] = {
            marginRight: theme.spacing(1),
            "& svg circle": {
                stroke: alt ? theme.palette.primary.main : theme.palette.background.paper
            }
        },
        _b);
});

export { classes, StyledKModalAction as default };
//# sourceMappingURL=index.styled.js.map
